export class PipeRegistry {
    constructor() {
        this.map = new Map();
    }
    registerPipe(name, pipe) {
        this.map.set(name, pipe);
    }
    getPipe(name) {
        return this.map.get(name);
    }
    getPipeN(names) {
        const pipes = [];
        for (const pipeName of names) {
            const registeredPipe = this.map.get(pipeName);
            if (!registeredPipe) {
                throw new Error(`Cannot find registered pipe`);
            }
            pipes.push(registeredPipe);
        }
        return (initialValue, context) => {
            let value = initialValue;
            for (const pipe of pipes) {
                value = pipe(value, context);
            }
            return value;
        };
    }
    runPipeN(names, value, context) {
        const pipe = this.getPipeN(names);
        return pipe(value, context);
    }
}
//# sourceMappingURL=index.js.map